<template>
  <v-form ref="promocodeEditForm" v-model="valid">
    <div class="back-btn" @click="$router.push({name: 'promocode-index'})">
      <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M36 27H23.83L29.42 21.41L28 20L20 28L28 36L29.41 34.59L23.83 29H36V27Z" fill="#8C959D"/>
      </svg>
    </div>
    <v-row>

      <v-col  cols="12">

        <div class="d-flex">
        <h1 class="mb-16">{{ promocode.id ? 'Редактировать промокод #' + promocode.id : 'Создать промокод'}}</h1>

        <a class="ml-auto mr-1 text-decoration-underline clickable" :href="'/push?promocode='+promocode.code" v-if="promocode.id && !showBlocked">создать уведомление</a>
        <div class="ml-1 mr-1 text-decoration-underline clickable" @click="showBlockedScreen()" v-if="promocode.id && !showBlocked">показать у кого заблокирован</div>
        <div class="ml-1 mr-1 text-decoration-underline clickable" @click="showBlocked=false" v-if="promocode.id && showBlocked">вернуться к деталям</div>
        </div>

      </v-col>

      <v-col  cols="12" v-if="showBlocked">
        <div v-if="blockedLoading">загрузка...</div>
        <div v-if="!blockedLoading && !blockedList.length">нет заблокированных</div>
        <table v-if="!blockedLoading && blockedList.length" class="table-list">
        <thead>
        <tr>
          <th>User(link)</th>
          <th>Email</th>
          <th>Телефон</th>
        </tr>
        </thead>
          <tr v-for="blocked in blockedList">
          <td><a :href="'/user/' + blocked.user.id">{{blocked.user.name}}</a></td> <td>{{blocked.user.email}}</td> <td>{{blocked.user.phone}}</td>
        </tr>
        </table>
      </v-col>
      <v-col  cols="12" sm="12" md="8" xl="5"  :style="showBlocked ? 'display: none;' : ''">


        <v-row>
        <v-col cols="12" sm="6">
        <v-text-field
            v-model="promocode.name"
            label="Название на русском"
            :rules="[rules.required]"
            required
            outlined
        ></v-text-field>
        </v-col>

        <v-col cols="12" sm="6">
        <v-text-field
            v-model="promocode.name_ua"
            label="Название на украинском"
            :rules="[rules.required]"
            required
            outlined
        ></v-text-field>
        </v-col>


          <v-col cols="12" sm="6">
            <v-dialog
                ref="timeDialog"
                v-model="timeModal"
                :return-value.sync="promocode.date_from"
                width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="promocode.date_from"
                    label="Начинает действовать с"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="promocode.date_from"
                  full-width
              >
                <v-spacer></v-spacer>
                <v-btn
                    text
                    color="primary"
                    @click="timeModal = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                    text
                    color="primary"
                    @click="$refs.timeDialog.save(promocode.date_from  )"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-dialog>
          </v-col>
          <v-col cols="12" sm="6">
            <v-dialog
                ref="timeDialog2"
                v-model="timeModal2"
                :return-value.sync="promocode.date_to"
                width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="promocode.date_to"
                    label="Действует до"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="promocode.date_to"
                  full-width
              >
                <v-spacer></v-spacer>
                <v-btn
                    text
                    color="primary"
                    @click="timeModal2 = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                    text
                    color="primary"
                    @click="$refs.timeDialog2.save(promocode.date_to  )"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-dialog>
          </v-col>
          <v-col cols="12" sm="6">

            <v-text-field
                :disabled="!!promocode.id && (!!promocode.count_use || !!promocode.entity_exists)"
                v-model="promocode.code"
                label="Код"
                :rules="[rules.required, rules.formatCode]"
                outlined
                append-icon="mdi-cube-outline"
                @click:append="generateCode()"
            ></v-text-field>

          </v-col>

        <v-col cols="12" sm="6">
        <v-select
            :items="types"
            :item-text="type => type.name"
            :item-value="type => type.id"
            v-model="promocode.type"
            label="Тип"
            outlined
        ></v-select>
        </v-col>


          <v-col cols="12" sm="6"  v-if="!promocode.id || promocode.id && promocode.bonus">
            <v-text-field
                    v-model="promocode.bonus"
                    label="Бонусы"
                    outlined
            ></v-text-field>

          </v-col>


          <v-col cols="12" sm="6" v-if="!promocode.id || !promocode.bonus">
            <v-text-field
                    v-model="promocode.min_price"
                    label="Минимальная сумма заказа"
                    outlined
            ></v-text-field>

          </v-col>

          <v-col cols="12" sm="6"  v-if="!promocode.id || !promocode.bonus">


            <v-autocomplete
                :items="productCategories"
                :item-text="type => type.name"
                :item-value="type => type.id"
                v-model="promocode.product_condition"
                label="Блюдо-условие (чтобы этот промокод можно было применить)"
                outlined
                clearable
            ></v-autocomplete>

          </v-col>

          <v-col cols="12" sm="6">
            <v-select
                :items="branches"
                :item-text="type => type.name"
                :item-value="type => type.id"
                v-model="promocode.branches"
                label="Филиалы"
                outlined
                multiple
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6">
            <v-select
                :items="areas"
                :item-text="type => type.name"
                :item-value="type => type.id"
                v-model="promocode.areas"
                label="Район"
                outlined
                multiple
            ></v-select>
          </v-col>

          <v-col cols="12" sm="6">
            <v-select
                :items="delivery_type"
                :item-text="type => type.name"
                :item-value="type => type.id"
                v-model="promocode.delivery_type"
                label="Тип доставки"
                outlined
            ></v-select>
          </v-col>



          <v-col cols="12" sm="6">
            <v-select
                :items="branches"
                :item-text="type => type.name"
                :item-value="type => type.id"
                v-model="promocode.self_delivery_branches"
                label="Разрешить для самовывоза в филиалах"
                outlined
                multiple
            ></v-select>
          </v-col>


        </v-row>
        <v-btn :loading="loadingButton" v-if="id" @click="update">Сохранить</v-btn>
        <v-btn :loading="loadingButton" v-else @click="create">Создать</v-btn>
      </v-col>

      <v-snackbar
          :style="showBlocked ? 'display: none;' : ''"
              v-model="snackbar"
              :timeout="timeout"
              :color="snackbarColor"
              right
              top
      >
        {{ snackbarText }}
      </v-snackbar>
    </v-row>
    <v-row v-if="promocode.id && !promocode.bonus" :style="showBlocked ? 'display: none;' : ''">
      <v-col>
        <promocode-products v-model="promocode" :loading="loading"></promocode-products>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
  // @ is an alias to /src
  import PromocodeService from './../../api/PromocodeService'
  import PromocodeProducts from './Tables/PromocodeProducts'
  import moment from 'moment'
  import ProductsModal from "@/components/ProductsModal.vue";
  import ProductService from "@/api/ProductService";
  import BranchService from "@/api/BranchService";
  import AreaService from "@/api/AreaService";

  export default {
    name: 'PromocodeEdit',
    props: {
        id: {
            default: null,
        }
    },
    components: {ProductsModal, PromocodeProducts},
    data() {
      return {
        showBlocked: false,
        branches: [],
        areas: [],
        delivery_type: [
          {name: 'Нет', id: '0'},
          {name: 'Только Доставка', id: '1'},
          {name: 'Только Самовывоз', id: '2'},
        ],
        types: [
          {
            id: 1,
            name: 'Одноразовый (может быть введен / выдан только единожды)'
          },
          {
            id: 2,
            name: 'Многоразовый (любой может использовать сколько хочет)'
          },
          {
            id: 3,
            name: 'Многоразово-одноразовый (каждый может использовать 1 раз)'
          },
          {
            id: 4,
            name: 'Ручная выдача (нельзя ввести, но можно выдать)'
          },
          {
            id: 0,
            name: 'Старый (тип не задан)'
          },
        ],
        productCategories: [],
        snackbar: false,
        timeout: 2000,
        snackbarText: '',
        snackbarColor: '',
        timeModal: false,
        timeModal2: false,
        timeModal3: false,
        tabLang: '',
        rules: {
          required: value => !!value || 'Нужно заполнить',
          formatCode: value => !!value && /^[a-zA-Z0-9]+$/.test(value || '') || 'Только английские буквы и цифры',
          requiredSelect: [(v) => !!v.id || 'Нужно заполнить'],
        },
        valid: true,
        promocode: {
          name: '',
          name_ua: '',
          code: '',
          bonus: '',
          min_price: '',
          date_to: null,
          date_from: null,
          is_multiple: false,
          product_condition: null,
          type: 3,
          branches: [],
          self_delivery_branches: [],
          areas: [],
          delivery_type: '0',
        },
        loading: true,
        loadingButton: false,
        blockedLoading: false,
        blockedList: [],
      }
    },
    mounted() {
        this.init()
    },
    methods: {
      showBlockedScreen() {
        this.showBlocked = true;
        this.blockedLoading = true;

        PromocodeService.showBlocked(this.promocode.code).then((res) => {
          this.blockedList = res.data.blocked;
          this.blockedLoading = false;
        });
      },
      to16x(value) {
        return Math.round(value).toString(32)
      },
      generateCode() {
        this.promocode.code =
            this.to16x(Math.random() * 1000000) +
            this.to16x(Math.random() * 1000000);
      },
      validate () {
        this.valid = true;
        this.snackbar = false;
        if (this.promocode.type !== 1 && this.promocode.type !== 4 && this.promocode.bonus) {
          this.snackbar = true;
          this.snackbarText = 'Нельзя создать многоразовый промокод с бонусом';
          this.snackbarColor = 'error';
          this.valid = false;
          return;
        }

        if (this.promocode.product_condition && this.promocode.bonus) {
          this.snackbar = true;
          this.snackbarText = 'Нельзя создать промокод с блюдом-условием и с бонусом';
          this.snackbarColor = 'error';
          this.valid = false;
          return;
        }

        if (this.promocode.min_price && this.promocode.bonus) {
          this.snackbar = true;
          this.snackbarText = 'Нельзя создать промокод с минимальной суммой заказа и с бонусом';
          this.snackbarColor = 'error';
          this.valid = false;
          return;
        }


        this.$refs.promocodeEditForm.validate();

      },
      init(){
        if(this.id) {
          PromocodeService.get(this.id)
            .then(response => {
              this.promocode = {...response.data,
                branches: (response.data.branches || '').split(',').filter(val => val.length).map(val => +val),
                self_delivery_branches: (response.data.self_delivery_branches || '').split(',').filter(val => val.length).map(val => +val),
                areas: (response.data.areas || '').split(',').filter(val => val.length).map(val => +val),
              };

              console.log(this.promocode);
              this.loading = false
            });
        }

        ProductService.listByCategory({withChild: true}).then(response => {
          const productCategories = [];

          for (const category of response.data) {
            productCategories.push({header: category.name});

            for (const product of category.products.sort((a, b) => a.name.localeCompare(b.name))) {
              productCategories.push({
                id: product.id,
                name: product.name
              });
            }
          }

          this.productCategories = productCategories;
        });

        BranchService.list().then(response => {
          this.branches = response.data;
        })

        AreaService.list().then(response => {
          this.areas = response.data;
        });
      },
      update(){
        this.validate()
        if(!this.valid){
          return false
        }
        this.loadingButton = true;
        let formData = this.getData();

        PromocodeService.update(formData).then(response => {
          this.snackbar = true;
          this.snackbarText = 'Промокод успешно обновлен';
          this.snackbarColor = 'success';
          this.promocode.id = response.data.id;
        }).catch(error => {
          const message = error.response?.data?.message;
          this.snackbar = true;
          this.snackbarText = message === 'This code already exists' ? `Код ${this.promocode.code} уже существует` : 'Ошибка при обновлении промокода';
          this.snackbarColor = 'error';
        }).finally(() => {
          this.loadingButton = false
        })
      },
      create(){
        this.validate()
        if(!this.valid){
          return false
        }
          this.loadingButton = true;
          var formData = this.getData();

          PromocodeService.create(formData).then(response => {
            this.snackbar = true;
            this.snackbarText = 'Промокод успешно создан';
            this.snackbarColor = 'success';
            this.$router.push({ name: 'promocode-edit', params: { id: response.data.id } })
            this.id = this.promocode.id = response.data.id;
            this.init();
          }).catch(error => {
            const message = error.response?.data?.message;
            this.snackbar = true;
            this.snackbarText = message === 'This code already exists' ? `Код ${this.promocode.code} уже существует` : 'Ошибка при обновлении промокода';
            this.snackbarColor = 'error';
          }).finally(() => {
            this.loadingButton = false
          })
      },
      getData() {
          let formData = new FormData();
          let time = moment('2020-01-01 ' + this.promocode.default_delivery_time).format('HH:mm:ss')

          formData.append('id', this.id || this.promocode.id);
          formData.append('name', this.promocode.name);
          formData.append('name_ua', this.promocode.name_ua);
          formData.append('min_price', this.promocode.min_price);
          if(this.promocode.date_to){
            formData.append('date_to', this.promocode.date_to);
          }
          if(this.promocode.date_from){
            formData.append('date_from', this.promocode.date_from);
          }
          formData.append('is_multiple', this.promocode.is_multiple ? 1 : 0);
          formData.append('code', this.promocode.code);
          formData.append('bonus', this.promocode.bonus);
          formData.append('type', this.promocode.type);
          formData.append('product_condition', this.promocode.product_condition || null);
          formData.append('branches', (this.promocode.branches || []).join(','));
          formData.append('self_delivery_branches', (this.promocode.self_delivery_branches || []).join(','));
          formData.append('areas', (this.promocode.areas || []).join(','));
          formData.append('delivery_type', this.promocode.delivery_type);

          return formData;
      }
    },
  }
</script>

<style scoped lang="scss">
  .clickable {
    user-select: none;
    cursor: pointer;
  }
  .image-placeholder{
    width: 100%;
    height: 100%;
    background-color: #F3F7FC;
    border-radius: 4px;
  }
  .promocode-images .v-image{
    max-height: 374px;
  }
  .table-list {
    min-width: 100%;
  }
  .table-list td, .table-list th {
    padding: 5px 10px;
  }
  .table-list th {
    text-align: left;
  }
  .promocode{
    position: relative;
    &:before{
      content: "";
      padding-top: 100%;
      display: block;
    }

    .content{
      position: absolute;
      width: 100%;
      left: 0;
      top: 0;
      height: 100%;
      background-color: #F8FBFF;
      border-right-style: 3px;
      .img{
        height: 3.541vw;
        margin-top: .83vw;
      }
      .name{
        margin-top: .72vw;
        text-align: center;
        color: #8C959D;
      }
    }
  }
</style>
